import React from 'react'

import ucFirst from 'vegas-js-core/src/strings/ucFirst'

import withConfig  from '../../contexts/config/withConfig'
import withDialogs from '../../contexts/dialogs/withDialogs'
import withi18n    from '../../contexts/i18n/withi18n'

import { withRouter } from 'react-router-dom'
import { withStyles } from '@material-ui/core/styles'

import { Chip } from '@material-ui/core'

import blueGrey from '@material-ui/core/colors/blueGrey'

import NotInterestedIcon from '@material-ui/icons/NotInterested'

import ThingContainer from '../containers/ThingContainer'

import Place   from '../../things/Place'
import ThingVO from '../../things/Thing'
import Word    from '../../things/Word'

const styles = theme => (
{
    chip :
    {
        borderColor : blueGrey[100],
        margin      : theme.spacing(0.5)
    }
});

class Prohibitions extends ThingContainer
{
    editInit = ( item ) =>
    {
        if( item )
        {
            const { prohibitions } = item ;
            if( prohibitions instanceof Array )
            {
                return prohibitions.map( element =>
                {
                    if( element instanceof Word )
                    {
                        return element.clone() ;
                    }
                    return null ;
                })
            }
        }
        return null ;
    };

    editPrepare = ( datas ) =>
    {
        if( datas instanceof Array )
        {
            datas = datas.map( item => item instanceof Word ? item.id : null ) ;
            let object = datas.join(',');
            object = { prohibitions : object  } ;
            return object;
        }
        return null ;
    };

    getBadgeLabel = () =>
    {
        const { thing } = this.props ;
        if( thing )
        {
            const { prohibitions } = thing  ;
            if( (prohibitions instanceof Array) )
            {
                return prohibitions.length ;
            }
        }
        return 0 ;
    };

    getContent = () =>
    {
        const { classes, lang, thing } = this.props ;
        if( thing )
        {
            let { prohibitions } = thing ;

            if( prohibitions instanceof Array && prohibitions.length > 0 )
            {
                let css = { paddingLeft:8,marginRight:0, height:24, width:24 } ;

                prohibitions = prohibitions.map( ( item , index ) =>
                {
                    if( item instanceof Word )
                    {
                        const label = ucFirst(item.getLocaleName( lang ));
                        const icon  = this.getImage(item,css);
                        return (
                        <Chip
                            className = { classes.chip }
                            clickable = { false }
                            key       = { 'activity_' + index }
                            icon      = { icon }
                            label     = { label }
                            variant   = 'outlined'
                        />);
                    }
                    return null ;
                });

                return (
                    <div className="flex flex-row flex-wrap">
                        { prohibitions }
                    </div>
                )
            }
        }
        return null ;
    };

    getEntry = init =>
    {
        let empty = {} ;
        if( init instanceof ThingVO )
        {
            empty = init.toObject() ;
        }
        else if( init )
        {
            empty = { ...init } ;
        }
        return new Place(empty) ;
    };

    getLocale = () => this.props.locale.things.prohibitions ;
}

Prohibitions.defaultProps =
{
    ...ThingContainer.defaultProps ,
    badge      : true ,
    icon       : <NotInterestedIcon/>,
    optionMode : 'edit'
};

Prohibitions.propTypes =
{
    ...ThingContainer.propTypes
};

export default withStyles( styles ) ( withRouter( withConfig( withi18n( withDialogs(Prohibitions) ) ) ) ) ;
